// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1hq7y","content":"styles_content___5yv9","selectAll":"styles_selectAll__4YQCA"};